import { FunctionComponent, memo, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Faq as FaqType } from '~types';
import Container from '../container';
import TextHeading from '../text-heading';
import FAQ from './FaqModul';
import "./page.scss";


interface FaqComponentTyps {
  faqData: FaqType[];
  goPage: (event: SyntheticEvent<HTMLDivElement>) => void;
}

const Faq: FunctionComponent<FaqComponentTyps> = ({
  faqData,
  goPage
}) => {
  const { i18n: { language }, } = useTranslation();
  

  return (
    <div className="faq">
      <Container>
        <TextHeading title="FAQ" />
        <FAQ language={language} faqData={faqData} goPage={goPage} />
      </Container>
    </div>
  );
};

export default memo(Faq);
